import Appartment from "images/appartment.svg";
import Building from "images/building.svg";
import House from "images/house.svg";
import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { useSpring, animated } from "react-spring";
import { MdClose } from "react-icons/md";
import { RewardManagementContext } from "../context/RewardManagementContext";
import { toast } from "react-toastify";
const Model = ({ showModal, setShowModal }) => {
  const initialValue = { moduleName: "", totalMSTATE: "0", iAgree: false, tierId:"" };

  const [formValues, setFormValues] = useState(initialValue);

  const { createNode } = useContext(RewardManagementContext);

  const handleChange = (e) => {
    //console.log(e.target);

    //const {name, value } =  e.target;
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setFormValues({ ...formValues, [name]: value });
    console.log(formValues);
  };

  const handleSubmit = (e) => {
    const { moduleName, totalMSTATE, iAgree, tierId } = formValues;
    console.log("iAgree " + iAgree);
    e.preventDefault();

    if (tierId === "") {
      toast.error("Please select module to purchase", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (!moduleName) {
      toast.error("Please provide module name", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (!iAgree) {
      toast.error(
        "Please check the checkbox if you agree to the terms and condition",
        {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    }

    console.log(formValues);
    createNode(formValues);
    
  };

  const [activeId, setActiveId] = useState();
  //   const totalMSTATE = useState();

  const [totalMSTATE, settotalMSTATE] = useState("0");
  const [tierId, setTierId] = useState("0");

  const [iAgree, setiAgre] = useState(false);

  const setBuyingTotal = (total) => {
    console.log("you just clicked" + total);
    settotalMSTATE(total);
    setFormValues({ ...formValues, totalMSTATE: total });
  };

  const setTier = (id) => {
    console.log("you just clicked" + id);
    setTierId(tierId);
    setFormValues({ ...formValues, tierId: id });
  };

  // const Input = ({ placeholder, name, type, value, handleChange }) => (
  //   <input
  //     placeholder={placeholder}
  //     type={type}
  //     value={value}
  //     onChange={(e) => handleChange(e)}
  //     className="my-2 w-full rounded-sm p-2 outline-none bg-transparent text-white border-none text-sm white-glassmorphism"
  //   />
  // );

  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  const modalRef = useRef();
  const animation = useSpring({
    config: {
      duration: 250,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? "translateY(0%)" : "translateY(-100%)",
  });

  const values = [
    {
      id: 0,
      name: "Appartment",
      total: "1",
      reward: "2000%",
      earn: "0.02",
      src: Appartment,
    },
    {
      id: 1,
      name: "Building",
      total: 5,
      reward: "2300%",
      earn: "0.246",
      src: Building,
    },
    {
      id: 2,
      name: "House",
      total: 10,
      reward: "2600%",
      earn: "0.556",
      src: House,
    },
  ];

  return (
    <>
      {showModal ? (
        <div className="createNode top-2/4" >
          <form>
            <div className="model-head">
              <a
                className="closeBtn"
                onClick={() => setShowModal((prev) => !prev)}
              >
                <MdClose />
              </a>
              <p className="text-justify">
                Start earning lifetime high-yield $MSTATE token rewars. Rewards
                calculations are based on many factors, including the number of
                nodes, node revenue, token price, and protocol revenue, and they
                are variable.{" "}
              </p>
            </div>
            <div className="model-content">
              {values.map((val) => (
                <div key={val.id}>
                  <a
                    href="#"
                    className={activeId === val.id ? "active" : "inactive"}
                    onClick={() => {
                      setActiveId(val.id);
                      //setBuyingTotal(val.total);
                      setTier(val.id);
                    }}
                  >
                    <div className="node-type">
                      <img
                        src={val.src}
                        alt="logo"
                        className="cursor-pointer "
                        style={{ color: "white" }}
                      />
                    </div>
                    <div className="model-text">
                      <h3>{val.name}</h3>
                      <p>
                        {val.total} $MSTATE
                        <br /> {val.reward} <br />
                        Earn {val.earn}/day
                      </p>
                    </div>
                  </a>
                </div>
              ))}
            </div>
            <div className="model-footer">
              <div className="mt-2 text-white text-xs mt-2">
                <p>
                  *rate is calculated with the actual $MSTAT price and it may
                  vary depending on variouse factor{" "}
                </p>
              </div>
              <div className="mt-5 mb-5 p-2 w-full flex flex-col justify-start items-center white-glassmorphism rounded-md ">
                <input
                  className="my-2 w-full rounded-sm p-2 outline-none bg-transparent text-white border-white text-sm white-glassmorphism"
                  placeholder="Module Name"
                  name="moduleName"
                  type="text"
                  value={formValues.moduleName}
                  onChange={handleChange}
                />
              </div>

              <div className="text-white text-sm mt-2">
                <p>
                  A contribution of $MSTATE token to the MSTATE community is
                  required to create a node and participate in rewards.
                </p>
              </div>
              <div className="text-white text-xs mt-2">
                <p>Your $MSTATE token will be distributed as follows:</p>
                <ul>
                  <li>20% future use</li>
                  <li>10% to MSTATE-AVAX Pool for rewards</li>
                  <li>70% into node rewards pool</li>
                  <li>Distribution subject to optimization over time</li>
                </ul>

                <div className="mt-5 mb-5 p-2 flex flex-row justify-start items-center white-glassmorphism rounded-md">
                  <input
                    name="iAgree"
                    type="checkbox"
                    className="ml-2 indeterminate:bg-gray-300"
                    value={formValues.iAgree}
                    onChange={handleChange}
                  />

                  <label title="" className="text-sm text-white ml-5">
                    <span>
                      I have read the
                      <a href="https://mstate.financial/disclaimer.html">
                        disclaimer
                      </a>
                      and I want to create my MSTATE-node.
                    </span>
                  </label>

                  <input
                    name="totalMstate"
                    type="hidden"
                    value={totalMSTATE}
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-5 mb-5 p-0 flex flex-row justify-end items-center rounded-md place-items-end">
                  <a className="btn " href="#" onClick={handleSubmit}>
                    <span>Create Node</span>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      ) : null}
    </>
  );
};
export default Model;
